import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, MessageCircle, Youtube } from 'lucide-react';
import { categories } from '../../utils/calculators';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: 'var(--bg-card)', borderTop: '2px solid var(--border)', marginTop: '40px' }}>
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Links grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
          <div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Calculators</div>
            {categories.slice(0, 5).map(cat => (
              <Link key={cat.id} to={cat.path} style={{ display: 'block', fontSize: '20px', color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: '5px' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-secondary)')}
              >
                {cat.name}
              </Link>
            ))}
          </div>
          <div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Markets</div>
            {categories.slice(5).map(cat => (
              <Link key={cat.id} to={cat.path} style={{ display: 'block', fontSize: '20px', color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: '5px' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-secondary)')}
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/calculators" style={{ display: 'block', fontSize: '20px', color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: '5px' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-secondary)')}
            >
              All Calculators
            </Link>
          </div>
          <div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Popular Tools</div>
            {[
              { name: 'Stock Average Calculator', path: '/calculators/stock-average-calculator' },
              { name: 'US Capital Gains Tax', path: '/calculators/us-capital-gains' },
              { name: 'India Capital Gains Tax', path: '/calculators/india-capital-gains' },
              { name: 'P/E Ratio Calculator', path: '/calculators/pe-ratio' },
              { name: 'Dividend Yield Calculator', path: '/calculators/dividend-yield' },
              { name: 'ROI Calculator', path: '/calculators/roi' },
              { name: 'CAGR Calculator', path: '/calculators/cagr' },
              { name: 'SIP Calculator', path: '/calculators/sip' },
              { name: 'Position Size Calculator', path: '/calculators/position-size' },
              { name: 'Options Profit Calculator', path: '/calculators/options-profit' },
              { name: 'Currency Converter', path: '/calculators/currency-converter' },
              { name: 'State CGT Calculator', path: '/calculators/us/state-capital-gains' },
              { name: 'Tax-Equivalent Yield', path: '/calculators/us/tax-equivalent-yield' },
              { name: 'Capital Loss Carryforward', path: '/calculators/us/capital-loss-carryforward' },
              { name: 'Tax Lot Optimizer', path: '/calculators/us/tax-lot-optimizer' },
              { name: 'HSA Tax Savings', path: '/calculators/us/hsa-tax-savings' },
              { name: 'QBI (199A) Deduction', path: '/calculators/us/qbi-199a' },
              { name: 'Estate Tax Calculator', path: '/calculators/us/estate-tax' },
              { name: 'Cost Segregation', path: '/calculators/us/cost-segregation' },
            ].map(item => (
              <Link key={item.path} to={item.path} style={{ display: 'block', fontSize: '20px', color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: '5px' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-secondary)')}
              >
                {item.name}
              </Link>
            ))}
          </div>
          <div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Company</div>
            {[
              { name: 'About Us', path: '/about' },
              { name: 'Contact', path: '/contact' },
              { name: 'Privacy Policy', path: '/privacy-policy' },
              { name: 'Terms & Conditions', path: '/terms' },
              { name: 'Disclaimer', path: '/disclaimer' },
              { name: 'DMCA', path: '/dmca' },
              { name: 'Cookie Policy', path: '/cookie-policy' },
              { name: 'GDPR', path: '/gdpr' },
              { name: 'AdSense Disclosure', path: '/adsense-disclosure' },
              { name: 'Affiliate Disclosure', path: '/affiliate-disclosure' },
              { name: 'Sitemap', path: '/sitemap' },
            ].map(item => (
              <Link key={item.path} to={item.path} style={{ display: 'block', fontSize: '20px', color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: '5px' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-secondary)')}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <img src="/logos/stock-marketor-logo-footer.webp" alt="StockMarketor.Com Logo" width="311" height="48" style={{ height: '48px', width: 'auto', marginBottom: '8px' }} />
            <p style={{ fontSize: '16px', color: 'var(--text-muted)', margin: '0 0 16px 0' }}>Empowering your financial journey with free, powerful tools.</p>
            
            <div style={{ display: 'flex', gap: '24px', fontSize: '14px', color: 'var(--text-muted)', marginBottom: '16px' }}>
              <div>
                <strong>Headquarters:</strong><br />
                27 Main, Sector 2 HSR Layout<br />
                Bangalore, KA INDIA 560102
              </div>
              <div>
                <strong>United States:</strong><br />
                8555 Main Street West<br />
                Huntington, NY 11743
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              {[
                { name: 'Facebook', icon: <Facebook size={20} />, href: 'https://www.facebook.com/stockmarketor' },
                { name: 'Twitter', icon: <Twitter size={20} />, href: 'https://twitter.com/stockmarketor' },
                { name: 'LinkedIn', icon: <Linkedin size={20} />, href: 'https://www.linkedin.com/company/stockmarketor' },
                { name: 'Instagram', icon: <Instagram size={20} />, href: 'https://www.instagram.com/stockmarketorofficial/' },
                { name: 'YouTube', icon: <Youtube size={20} />, href: 'https://www.youtube.com/@stockmarketor' },
              ].map((social, idx) => (
                <a key={idx} href={social.href} aria-label={social.name} style={{ color: 'var(--text-muted)', transition: 'color 0.2s' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--accent)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}>
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '16px', fontSize: '18px' }}>
            {[
              { name: 'Privacy', path: '/privacy-policy' },
              { name: 'Terms', path: '/terms' },
              { name: 'Disclaimer', path: '/disclaimer' },
              { name: 'Contact', path: '/contact' },
            ].map(item => (
              <Link key={item.path} to={item.path} style={{ color: 'var(--text-muted)', textDecoration: 'none' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-muted)')}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border)', marginTop: '24px', paddingTop: '24px', textAlign: 'center', fontSize: '16px', color: 'var(--text-muted)' }}>
          &copy; {year} StockMarketor.Com. All rights reserved. For educational use only. Not financial advice.
        </div>
      </div>
    </footer>
  );
}
